/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable array-callback-return */
import Roboto from '../../../../../../assets/fonts/Roboto-Bold.ttf'

import {
  Defs,
  Document,
  Font,
  G,
  Image,
  Image as PDFImage,
  LinearGradient,
  Page,
  Path,
  Rect,
  Stop,
  StyleSheet,
  Svg,
  Text,
  View
} from '@react-pdf/renderer'
import { iRelatorioIndividualSI, iRelatorioSI } from '../../interfaceRelatorioSI'
import CapaImage from '../../assets/Capa.png'
import LogoImage from '../../assets/Logo.png'
import Logo from '../../assets/LogoColorida.png'
import { Footer } from './Components/Footer'
import React from 'react'
import { DominanciaSectionProps } from '../RelatorioPDF'

interface iProps {
  model: iRelatorioIndividualSI
}

export const RelatorioIndividualPDF: React.FC<iProps> = ({
  model
}) => {
  Font.register({
    family: 'Roboto',
    fonts: [{
      src: Roboto
    }]
  })

  const styles = StyleSheet.create({
    DefaultPage: {
      flexDirection: 'column',
      paddingBottom: '56px',
      justifyContent: 'space-between'
    },
    Sumario: {
      backgroundColor: model.corEmpresa ?? '#1961E0',
      flexDirection: 'column',
      justifyContent: 'center',
      color: 'white',
      padding: 32
    },
    Capa: {
      position: 'relative',
      backgroundColor: model.corEmpresa
    },
    FlexCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    Image: {
      objectFit: 'cover'
    },
    Title: {
      fontSize: '28px',
      color: model.corEmpresa ?? '#1961E0',
      fontFamily: 'Roboto',
      textAlign: 'center'
    },
    ContentPage: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      paddingHorizontal: '32px',
      fontSize: '12px'
    },
    ContentTitle: {
      fontSize: '14px',
      fontFamily: 'Roboto'
    }
  })

  function GetPontosRelacionamento(): any {
    return <View style={{ paddingHorizontal: '18px', paddingTop: '0.01px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <View style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'row', gap: '6px' }}>
        <Text style={{ fontSize: '16px', fontFamily: 'Roboto', color: '#EB5757', paddingBottom: '4px', width: '100%', borderBottom: '1px solid rgb(194, 194, 194)' }}>Comportamentos Mais Fortes</Text>
      </View>
      <View style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <Text style={{ fontSize: '12px', fontFamily: 'Roboto' }}>{model.nome} expressará mais fortemente os seguintes comportamentos</Text>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: '8px' }}>
          {model.comportamentosPI.split('\n•').map(e => {
            return <Text style={{ fontSize: '10px' }}>• {e}</Text>
          })}
        </View>
      </View>
    </View>
  }

  function GetResumo(): any {
    return <View style={{ paddingHorizontal: '18px', paddingTop: '0.01px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <View minPresenceAhead={40} style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'row', gap: '6px' }}>
        <Text style={{ fontSize: '16px', fontFamily: 'Roboto', color: '#EB5757', paddingBottom: '4px', width: '100%', borderBottom: '1px solid rgb(194, 194, 194)' }}>Resumo</Text>
      </View>
      <View style={{ paddingHorizontal: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '4px', paddingLeft: '8px' }}>
          {model.resumoPI.split('\n\n').map(e => {
            return <Text style={{ fontSize: '10px', textAlign: 'justify' }}>{e}</Text>
          })}
        </View>
      </View>
    </View>
  }

  const primeiraFolhaPagina: Record<number, number> = {}
  let qtdPaginas = 0

  function GetContentPage(children: any, secao: string, noFooter?: boolean, page?: string): any {
    const pagina = qtdPaginas++
    return (<Page size={'A4'} style={noFooter ? { ...styles.DefaultPage, paddingBottom: 0 } : styles.DefaultPage}>
      {/* a altura do cabecalho nao pode variar entre as folhas, senao o react-pdf calcula a quebra com o layout errado */}
      <View fixed style={{ paddingBottom: '16px' }}>
        {!model.corEmpresa
          ? <View>
          <Svg viewBox="0 0 210 40" width="210px" height="40px">
            <Defs>
              <LinearGradient id="myLinearGradient" x1="0" x2="1" y1="0" y2="0">
                <Stop offset="5%" stopColor="#1961E0" />
                <Stop offset="95%" stopColor="#66046B" />
              </LinearGradient>
            </Defs>

            <Rect fill="url(#myLinearGradient)" x="0" y="0" width="210" height={'40'} />
          </Svg>
        </View>
          : <View style={{ width: '100%', height: '40px', backgroundColor: model.corEmpresa }}>
        </View>}
        <Text style={{ position: 'absolute', top: '14px', right: '32px', fontSize: '10px', fontFamily: 'Roboto', color: model.corEmpresa ? 'white' : '#1961E0' }} render={({ pageNumber }) => {
          primeiraFolhaPagina[pagina] = Math.min(primeiraFolhaPagina[pagina] ?? pageNumber, pageNumber)

          return pageNumber > primeiraFolhaPagina[pagina] ? `${secao} (continuação)` : ''
        }}/>
      </View>
      <View style={{ flex: 1, marginBottom: '17px' }}>
        {children}
      </View>
      {!noFooter && <View fixed style={{ position: 'absolute', left: 0, right: 0, bottom: '32px' }}>
        <Footer nomeAvaliado={model.nome} nomeVaga={model.funcao.nome} numeroPagina={page}/>
      </View>}
      {noFooter && <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <Svg width="420" height="420" viewBox="0 0 420 420" fill={model.corEmpresa ?? '#1961E0'}>
            <Path d="M420 420H0V0L420 420Z" fill={model.corEmpresa ?? '#1961E0'}/>
          </Svg>
          <PDFImage src={Logo} style={{ ...styles.Image, maxHeight: '65px', marginBottom: '60px', maxWidth: '130px', zIndex: 999, marginRight: '20px' }}/>
        </View>}
    </Page>)
  }

  function GetColor(quadrante: string): string {
    if (quadrante === 'EXTREMAMENTE') return '#444444'
    if (quadrante === 'MUITO') return '#828282'
    return '#BBBBBB'
  }

  function isIntervaloAtivo(pontuacao: number, i: number, rangeNeutro: boolean): boolean {
    if (rangeNeutro && i === 2) return true

    const intervalos = [
      { min: -3.0, max: -2.1 },
      { min: -2, max: -1.01 },
      { min: -1, max: -0.19 },
      { min: 0.21, max: 1 },
      { min: 1.01, max: 2 },
      { min: 2.01, max: 3.0 }
    ]
    return !rangeNeutro && pontuacao >= intervalos[i].min && pontuacao <= intervalos[i].max
  }

  function GetDominanciaSection(pontuacao: number, {
    letra,
    titulo,
    coluna1A,
    coluna1B,
    dicasAutocoaching1,
    coluna2A,
    coluna2B,
    dicasAutocoaching2
  }: DominanciaSectionProps): any {
    const left = pontuacao < -0.2
    const right = pontuacao > 0.2
    const rangeNeutro = pontuacao >= -0.2 && pontuacao <= 0.2

    return (
    <View style={{ display: 'flex', flexDirection: 'column' }}>
      <Text style={{ fontSize: 12, fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: '6px' }}>{titulo}</Text>
      <View style={{ display: 'flex', width: '540px', flexDirection: 'row', gap: 0, position: 'relative', alignItems: 'flex-end' }}>
        {['EXTREMAMENTE', 'MUITO', ...(rangeNeutro ? ['NEUTRO'] : ['MODERADAMENTE', 'MODERADAMENTE']), 'MUITO', 'EXTREMAMENTE'].map((e, i) => {
          return <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#1961E0' : GetColor(e), border: `1px solid ${isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#1961E0' : GetColor(e)}`, borderLeft: ((!rangeNeutro && i === 3 && !left) || (left && i === 0)) ? '1px solid #1961E0' : undefined, height: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '32px' : '26px', width: rangeNeutro && i === 2 ? '182px' : '90px', borderRightColor: ((right && i === 5) || (!rangeNeutro && i === 2 && left)) ? '#1961E0' : undefined, borderTopColor: right && i > 2 ? '#1961E0' : left && i < 3 ? '#1961E0' : undefined, borderTopLeftRadius: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '4px' : undefined, borderTopRightRadius: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '4px' : undefined }}>
            <Text style={{ fontSize: 8, color: isIntervaloAtivo(pontuacao, i, rangeNeutro) ? '#fff' : GetColor(e) === '#BBBBBB' ? '#000' : '#fff' }}>{e}</Text>
          </View>
        })}
      </View>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '270px', paddingHorizontal: '12px', paddingTop: '12px', paddingBottom: '16px', border: `1px solid ${left ? '#1961E0' : '#C9C9C9'}`, borderTop: 'none', borderRight: left ? undefined : 'none', backgroundColor: left ? '#E3E3E3' : undefined, opacity: right ? 0.5 : undefined }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px', height: '125px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS FORTES</Text>
              {coluna1A.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS DE ATENÇÃO</Text>
              {coluna1B.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
          </View>
          <View style={{ height: '1px', width: '246px', backgroundColor: '#C9C9C9' }} />
          <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '240px' }}>
            <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>DICAS DE AUTOCOACHING</Text>
            {dicasAutocoaching1.map((item, index) => (
              <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
            ))}
          </View>
        </View>
        <View style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '270px', paddingHorizontal: '12px', paddingTop: '12px', paddingBottom: '16px', border: `1px solid ${right ? '#1961E0' : '#C9C9C9'}`, borderLeft: right ? '1px solid #1961E0' : left ? 'none' : undefined, borderTop: 'none', backgroundColor: right ? '#E3E3E3' : undefined, opacity: left ? 0.5 : undefined }}>
          <View style={{ display: 'flex', flexDirection: 'row', gap: '20px', height: '125px' }}>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS FORTES</Text>
              {coluna2A.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
            <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '123px' }}>
              <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>PONTOS DE ATENÇÃO</Text>
              {coluna2B.map((item, index) => (
                <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
              ))}
            </View>
          </View>
          <View style={{ height: '1px', width: '246px', backgroundColor: '#C9C9C9' }} />
          <View style={{ display: 'flex', flexDirection: 'column', gap: 3, width: '240px' }}>
            <Text style={{ fontSize: 10, textAlign: 'center', fontFamily: 'Roboto', fontWeight: 'bold', marginBottom: 4 }}>DICAS DE AUTOCOACHING</Text>
            {dicasAutocoaching2.map((item, index) => (
              <Text key={index} style={{ fontSize: 9, textAlign: 'justify' }}>· {item}</Text>
            ))}
          </View>
        </View>
      </View>
      <View
        style={{
          position: 'absolute',
          top: '44px',
          left: `${((pontuacao + 3) / 6) * 540 - 8}px`,
          width: 16,
          height: 16,
          borderRadius: 8,
          fontFamily: 'Roboto',
          fontWeight: 'bold',
          backgroundColor: '#fff',
          border: '1px solid #1961E0',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Text style={{ fontSize: 8, color: '#1961E0' }}>{letra}</Text>
      </View>
    </View>
    )
  }

  return (
    <Document>
      <Page size="A4" style={styles.Capa}>
        {!model.corEmpresa && <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
          <Svg viewBox="0 0 210 297" width="100%" height="100%">
            <Defs>
              <LinearGradient id="myLinearGradient" x1="0" x2="1" y1="0" y2="0">
                <Stop offset="5%" stopColor="#1961E0" />
                <Stop offset="95%" stopColor="#66046B" />
              </LinearGradient>
            </Defs>

            <Rect fill="url(#myLinearGradient)" x="0" y="0" width="210" height="297" />
          </Svg>
        </View>}
        <View style={{ ...styles.FlexCenter, padding: '60px 0 80px 0', marginHorizontal: '2px', backgroundColor: '#ffffff', flexDirection: 'column', gap: '14px', marginTop: '97px' }}>
          <Text style={{ fontSize: '34px', fontFamily: 'Roboto' }}>Assessment</Text>
          <View style={{ ...styles.FlexCenter, flexDirection: 'column', gap: '4px' }}>
            <Text style={{ fontSize: '20px', fontFamily: 'Roboto' }}>Nome: {model.nome}</Text>
            <Text style={{ fontSize: '20px', fontWeight: 'thin' }}>Vaga: {model.funcao.nome}</Text>
          </View>
          <Image src={model.logoEmpresa} style={{ ...styles.Image, height: '120px' }}/>
        </View>
        <View style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end', flexDirection: 'row', gap: '14px' }}>
          <PDFImage src={LogoImage} style={{ ...styles.Image, maxHeight: '65px', marginBottom: '60px', maxWidth: '150px', zIndex: 999 }}/>
          <PDFImage src={CapaImage} style={{ ...styles.Image, width: '340px', marginTop: '-60px', zIndex: 999 }}/>
        </View>
      </Page>

      {GetContentPage(
        <View style={{ ...styles.ContentPage, gap: '16px' }}>
          <Text style={{ ...styles.Title, marginBottom: '20px' }}>Introdução ao Assessment</Text>
          <Text style={{ ...styles.ContentTitle, marginBottom: '10px' }}>O que encontrará nesse relatório</Text>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={styles.ContentTitle}>1. Perfil Comportamental PI®</Text>
            <Text>
              Uma visão geral das principais características comportamentais da candidata, tais como estilo de liderança, comunicação e interação social.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={styles.ContentTitle}>2. Quadro de Desenvolvimento Pessoal</Text>
            <Text>
              Sugestões focadas em potencializar as competências da candidata, identificando oportunidades para o desenvolvimento de habilidades que possam contribuir para seu crescimento no cargo.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text>
              Este relatório serve como um feedback dos Assessments realizados, para que você possa utilizar essas informações em sua jornada contínua de desenvolvimento e aperfeiçoamento
            </Text>
          </View>
        </View>, 'Introdução ao Assessment', true
      )}

        {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '18px' }}>
          <Text style={styles.Title}>Relatório Comportamental PI®</Text>
          {/* <PDFImage src={imagens.find(e => e.id === 'relatorioComportamental')?.base64} style={{ width: '88%', height: '650px' }}/> */}
          {GetPontosRelacionamento()}
          {GetResumo()}
        </View>, 'Relatório Comportamental PI®')}

      {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '14px' }}>
        <Text style={{ ...styles.Title, marginBottom: '14px' }}>Quadro de desenvolvimento pessoal PI®</Text>
        {GetDominanciaSection(0.1, {
          letra: 'A',
          titulo: 'DOMINÂNCIA (A) - A necessidade de controlar',
          coluna1A: [
            'Compreensivo e colaborador',
            'Receptivo às decisões dos outros',
            'Estilo de gestão apoiador',
            'Interessado no bem-estar e desenvolvimento da equipe'
          ],
          coluna1B: [
            'Pode se esquivar de conversas difíceis',
            'Pode apresentar dificuldades para tomar decisões impopulares',
            'Pode ser visto como muito cauteloso ou não suficientemente estratégico'
          ],
          dicasAutocoaching1: [
            'Mude a sua mentalidade de "Eu quero acompanhar" para "Eu quero ser justo"',
            'Atenha-se ao seu ponto de vista quando souber que está correto',
            'Venha para reuniões ou situações preparado para contribuir'
          ],
          coluna2A: [
            'Conduz a mudança e desafia o status quo',
            'Busca liderar e apresentar um impacto',
            'Inovador, automotivado',
            "Capaz de pensar no 'quadro geral'"
          ],
          coluna2B: [
            'Pode ser visto como excessivamente agressivo',
            'Pode intimidar em vez de motivar',
            'Pode apresentar dificuldades para delegar autoridade',
            'Pode parecer muito pragmático e diretivo'
          ],
          dicasAutocoaching2: [
            'Busque ativamente por informações de diversas fontes',
            'Pratique a escuta ativa e permita que as pessoas expressem as suas opiniões ou ideias',
            'Pense antes de falar, reflita sobre como a sua mensagem será recebida'
          ]
        })}
        {GetDominanciaSection(-2, {
          letra: 'B',
          titulo: 'EXTROVERSÃO (B) - A necessidade de interação social',
          coluna1A: [
            'Criativo, solucionador de problemas',
            'Conduzido por dados, analítico',
            'Abordagem refletida para comunicar informações',
            'Reflexivo e introspectivo',
            'Antecipar problemas'
          ],
          coluna1B: [
            'Pode demorar a confiar e relutar em compartilhar até que se sinta à vontade',
            'A comunicação pode ser incisiva ou minimalista',
            'Pode parecer excessivamente voltado a tarefas ou remoto'
          ],
          dicasAutocoaching1: [
            'Faça apresentações na sua área de especialidade',
            'Inicie conversas ou reserve um tempo para falar com os outros',
            'Crie processos que incentivam a comunicação'
          ],
          coluna2A: [
            'Motivador, comunicador estimulante',
            'Orientado a pessoas, sociável',
            'Estabelece coesão e colaboração da equipe',
            'Delegante ponderado'
          ],
          coluna2B: [
            'Pode ser muito otimista ou excessivamente confiante',
            'Pode priorizar ser apreciado ou ser o foco das atenções',
            'Pode parecer excessivamente conversador e superficial'
          ],
          dicasAutocoaching2: [
            'Permita aos outros a oportunidade de contribuir e influenciar os resultados',
            'Leve em conta quantos detalhes ou informações concretas são necessários ao se comunicar',
            'Pergunte sobre problemas ou riscos em potencial'
          ]
        })}
      </View>, 'Quadro de desenvolvimento pessoal PI®')}
      {GetContentPage(<View style={{ ...styles.ContentPage, alignItems: 'center', paddingHorizontal: 0, gap: '14px' }}>
        <Text style={{ ...styles.Title, marginBottom: '14px' }}>Quadro de desenvolvimento pessoal PI®</Text>
        {GetDominanciaSection(-0.5, {
          letra: 'C',
          titulo: 'PACIÊNCIA (C) - A necessidade de estabilidade',
          coluna1A: [
            'Proativo e voltado a resultados',
            'Capaz de lidar com prazos urgentes',
            'Capaz de lidar com variedade e mudança',
            'Multitarefas, capaz de compatibilizar prioridades'
          ],
          coluna1B: [
            'Pode parecer ser brusco; "ir direto ao assunto"',
            'Pode tender a ser intolerante quanto a atrasos, especialmente quando afetam os resultados',
            'Pode ficar frustrado em ambientes estagnados'
          ],
          dicasAutocoaching1: [
            'Reflita sobre a urgência da situação – é preciso fazer tudo neste exato momento?',
            'Reconheça que pessoas têm ritmos diferentes e administre as expectativas',
            'Cumpra as prioridades e acompanhe iniciativas até a conclusão'
          ],
          coluna2A: [
            'Calmo e estável',
            'Ouvinte atencioso',
            'Estabelece processos sólidos de grupo',
            'Dá tempo às pessoas para que processem as informações'
          ],
          coluna2B: [
            'Pode parecer desconfortável com mudanças',
            'Pode parecer analisar muito as situações ou ser cauteloso',
            'Pode ter dificuldades sob pressão',
            'Mostra-se confortável com o familiar e lento para adotar ideias novas'
          ],
          dicasAutocoaching2: [
            'Esclareça os prazos e se concentre no "quando"',
            'Administre o tempo com sabedoria – comece cedo e reserve um tempo para o inesperado',
            'Mantenha os outros informados quando ocorrer progresso'
          ]
        })}
        {GetDominanciaSection(0.72, {
          letra: 'D',
          titulo: 'FORMALIDADE (D) - A necessidade de se adequar',
          coluna1A: [
            'Abordagem flexível ante a maioria das situações e pessoas',
            'Capaz de delegar detalhes facilmente',
            'Competente com necessidades de mudanças organizacionais',
            'Lida bem com a ambiguidade'
          ],
          coluna1B: [
            'Pode apresentar limitações quanto ao acompanhamento ou à atenção a detalhes',
            'Pode não aderir à estrutura ou direção',
            'Pode parecer para os outros muito casual ou desinibido'
          ],
          dicasAutocoaching1: [
            'Busque por dados para apoiar as suas decisões',
            'Avalie as decisões a partir de várias perspectivas ou associe-se a alguém que possa oferecer uma visão equilibrada',
            'Respeite as dúvidas que outros possam ter sobre "como" as coisas deverão ser feitas'
          ],
          coluna2A: [
            'Disciplina rígida e execução',
            'Cria uma estrutura e respeito pelo plano',
            'Concentra a equipe em como fazer as coisas bem feitas',
            'Acompanhamento organizado e minucioso'
          ],
          coluna2B: [
            'Pode não ficar à vontade em situações ambíguas',
            'Pode se debater com situações que requerem flexibilidade',
            'Pode ser visto como um perfeccionista'
          ],
          dicasAutocoaching2: [
            'Aprenda como avançar quando houver informações "suficientes" disponíveis',
            'Pergunte a si mesmo: Vale a pena tanto tempo?',
            'Reconheça e respeite a flexibilidade mostrada pelos outros'
          ]
        })}
      </View>, 'Quadro de desenvolvimento pessoal PI®')}

      <Page size={'A4'} style={{ ...styles.DefaultPage, paddingBottom: 0, justifyContent: 'flex-start' }}>
        <View style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', paddingLeft: '12px', paddingTop: '12px' }}>
          <Image src={model.logoEmpresa} style={{ ...styles.Image, height: '100px' }}/>
        </View>
        <View style={{ ...styles.ContentPage, paddingTop: '16px', gap: '16px', width: '70%', marginHorizontal: 'auto' }}>
          <Text style={{ ...styles.Title, marginBottom: '12px' }}>Assessment</Text>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={{ fontSize: '14px' }}>
              {model.nome}, agradecemos sua participação até essa etapa do processo seletivo.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={{ fontSize: '14px' }}>
              Compartilhamos com você os resultados do Assessment Comportamental.
            </Text>
          </View>
          <View style={{ flexDirection: 'column', gap: '3px' }}>
            <Text style={{ fontSize: '14px' }}>
              Parabéns pelo seu comprometimento e desejamos muito sucesso em sua jornada profissional.
            </Text>
          </View>
        </View>
        <Svg width="640" height="680" viewBox="0 0 640 680" fill={model.corEmpresa ?? '#1961E0'} style={{ position: 'absolute', bottom: 0, right: 0 }}>
          <Path d="M640 0V680H0L720 0Z" fill={model.corEmpresa ?? '#1961E0'}/>
        </Svg>
      </Page>
    </Document>
  )
}
